// /academy: the course catalog, a course's lesson list, and lesson pages,
// all inside the AcademyLayout docs frame. Open to every signed-in officer
// (trial, lapsed, solo, agency); lessons about gated features are readable by
// anyone and only their live walkthroughs are disabled. Progress comes from
// one provider so the pages and the sidebar badge share a single fetch.
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AcademyProgressProvider, useAcademyProgress } from "../progress";
import AcademyHome from "./AcademyHome";
import AcademyLayout from "./AcademyLayout";
import CoursePage from "./CoursePage";
import LessonPage from "./LessonPage";

const VisitStamp: React.FC = () => {
  const { markVisited } = useAcademyProgress();
  useEffect(() => {
    markVisited();
    // Once per mount of the section.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

const AcademyRouter: React.FC = () => (
  <AcademyProgressProvider>
    <VisitStamp />
    <Routes>
      <Route element={<AcademyLayout />}>
        <Route index element={<AcademyHome />} />
        <Route path=":courseId" element={<CoursePage />} />
        <Route path=":courseId/:lessonId" element={<LessonPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/academy" replace />} />
    </Routes>
  </AcademyProgressProvider>
);

export default AcademyRouter;
